import { render, staticRenderFns } from "./presentation-portrait.vue?vue&type=template&id=1f6a8dba&"
import script from "./presentation-portrait.vue?vue&type=script&lang=js&"
export * from "./presentation-portrait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports